"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationsPage = IntegrationsPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var client_1 = require("../../../features/apis/client");
var notification_1 = require("../../../features/apis/notification");
var content_dialog_1 = require("../../../features/thunks/content-dialog");
var hooks_1 = require("../../../store/hooks");
var integration_form_1 = require("./integration-form");
var telemetry_sync_dialog_1 = require("./telemetry-sync-dialog");
var availableIntegrations = [
    {
        type: "DIGITAL_TWIN",
        name: "Digital Twin",
        description: "Connect to a digital twin platform for real-time building monitoring, simulation, and data synchronization.",
        icon: "solar:buildings-3-linear",
        defaults: {
            baseUrl: "https://pistorius-group.digitaltwin.digital/api",
            protocol: "rpc",
            action: "login",
        },
    },
];
function IntegrationsPage() {
    var _this = this;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var clientId = (0, hooks_1.useAppSelector)(function (state) { return state.auth; }).clientId;
    var updateIntegration = (0, client_1.useUpdateClientIntegrationSettingsMutation)()[0];
    var _a = (0, client_1.useFetchClientQuery)(clientId, { skip: !clientId }), clientResponse = _a.data, isLoading = _a.isLoading;
    var configurations = (0, react_3.useMemo)(function () { var _a, _b; return ((_b = (_a = clientResponse === null || clientResponse === void 0 ? void 0 : clientResponse.content) === null || _a === void 0 ? void 0 : _a.integrationSettings) === null || _b === void 0 ? void 0 : _b.configurations) || []; }, [clientResponse]);
    var getConfigForType = function (type) {
        return configurations.find(function (c) { return c.type === type; });
    };
    var handleConfigure = function (integration) {
        var existing = getConfigForType(integration.type);
        var initialData = existing
            ? {
                baseUrl: existing.data.baseUrl,
                protocol: existing.data.protocol,
                action: existing.data.action,
                email: existing.data.email,
                password: existing.data.password,
            }
            : undefined;
        var handleSubmit = function (data) { return __awaiter(_this, void 0, void 0, function () {
            var otherConfigs, response, savedConfig, isActive, error_1, message;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 2, , 3]);
                        otherConfigs = configurations.filter(function (c) { return c.type !== integration.type; });
                        return [4 /*yield*/, updateIntegration({
                                _id: clientId,
                                integrationSettings: {
                                    configurations: __spreadArray(__spreadArray([], otherConfigs, true), [
                                        {
                                            type: integration.type,
                                            status: "ACTIVE",
                                            data: {
                                                baseUrl: data.baseUrl,
                                                protocol: data.protocol,
                                                action: data.action,
                                                email: data.email,
                                                password: data.password,
                                            },
                                        },
                                    ], false),
                                },
                            }).unwrap()];
                    case 1:
                        response = _f.sent();
                        if (response.success) {
                            dispatch(notification_1.notificationApi.util.invalidateTags(["notifications"]));
                            savedConfig = (_d = (_c = (_b = (_a = response.content) === null || _a === void 0 ? void 0 : _a.client) === null || _b === void 0 ? void 0 : _b.integrationSettings) === null || _c === void 0 ? void 0 : _c.configurations) === null || _d === void 0 ? void 0 : _d.find(function (c) { return c.type === integration.type; });
                            isActive = (savedConfig === null || savedConfig === void 0 ? void 0 : savedConfig.status) === "ACTIVE";
                            if (isActive) {
                                (0, react_1.addToast)({
                                    title: "Integration Saved",
                                    description: "".concat(integration.name, " has been configured successfully."),
                                    color: "success",
                                });
                            }
                            else {
                                (0, react_1.addToast)({
                                    title: "Integration Saved",
                                    description: "Configuration saved, but ".concat(integration.name, " could not connect. Please check your credentials."),
                                    color: "warning",
                                });
                            }
                            return [2 /*return*/, true];
                        }
                        else {
                            (0, react_1.addToast)({
                                title: "Save Failed",
                                description: response.message || "Could not save integration.",
                                color: "danger",
                            });
                            return [2 /*return*/, false];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _f.sent();
                        message = ((_e = error_1 === null || error_1 === void 0 ? void 0 : error_1.data) === null || _e === void 0 ? void 0 : _e.message) || "An error occurred while saving the integration.";
                        (0, react_1.addToast)({ title: "Save Failed", description: message, color: "danger" });
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        dispatch((0, content_dialog_1.showContentDialogThunk)({
            header: "Configure ".concat(integration.name),
            content: (0, jsx_runtime_1.jsx)(integration_form_1.IntegrationForm, { onSubmit: handleSubmit, initialData: initialData, defaults: integration.defaults }),
            contentMaxWidth: "max-w-lg",
            isDismissable: true,
        }));
    };
    var handleDisable = function (integration) { return __awaiter(_this, void 0, void 0, function () {
        var updatedConfigs, response, error_2, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    updatedConfigs = configurations.map(function (c) { return (c.type === integration.type ? __assign(__assign({}, c), { status: "INACTIVE" }) : c); });
                    return [4 /*yield*/, updateIntegration({
                            _id: clientId,
                            integrationSettings: { configurations: updatedConfigs },
                        }).unwrap()];
                case 1:
                    response = _b.sent();
                    if (response.success) {
                        dispatch(notification_1.notificationApi.util.invalidateTags(["notifications"]));
                        (0, react_1.addToast)({
                            title: "Integration Disabled",
                            description: "".concat(integration.name, " has been disabled."),
                            color: "warning",
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _b.sent();
                    message = ((_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.data) === null || _a === void 0 ? void 0 : _a.message) || "An error occurred.";
                    (0, react_1.addToast)({ title: "Update Failed", description: message, color: "danger" });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleEnable = function (integration) { return __awaiter(_this, void 0, void 0, function () {
        var updatedConfigs, response, savedConfig, isActive, error_3, message;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    updatedConfigs = configurations.map(function (c) { return (c.type === integration.type ? __assign(__assign({}, c), { status: "ACTIVE" }) : c); });
                    return [4 /*yield*/, updateIntegration({
                            _id: clientId,
                            integrationSettings: { configurations: updatedConfigs },
                        }).unwrap()];
                case 1:
                    response = _f.sent();
                    if (response.success) {
                        dispatch(notification_1.notificationApi.util.invalidateTags(["notifications"]));
                        savedConfig = (_d = (_c = (_b = (_a = response.content) === null || _a === void 0 ? void 0 : _a.client) === null || _b === void 0 ? void 0 : _b.integrationSettings) === null || _c === void 0 ? void 0 : _c.configurations) === null || _d === void 0 ? void 0 : _d.find(function (c) { return c.type === integration.type; });
                        isActive = (savedConfig === null || savedConfig === void 0 ? void 0 : savedConfig.status) === "ACTIVE";
                        if (isActive) {
                            (0, react_1.addToast)({
                                title: "Integration Enabled",
                                description: "".concat(integration.name, " has been enabled."),
                                color: "success",
                            });
                        }
                        else {
                            (0, react_1.addToast)({
                                title: "Integration Saved",
                                description: "".concat(integration.name, " could not connect. Please check your credentials."),
                                color: "warning",
                            });
                        }
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _f.sent();
                    message = ((_e = error_3 === null || error_3 === void 0 ? void 0 : error_3.data) === null || _e === void 0 ? void 0 : _e.message) || "An error occurred.";
                    (0, react_1.addToast)({ title: "Update Failed", description: message, color: "danger" });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleTelemetrySync = function () {
        dispatch((0, content_dialog_1.showContentDialogThunk)({
            header: "Sync Telemetry Data",
            content: (0, jsx_runtime_1.jsx)(telemetry_sync_dialog_1.TelemetrySyncDialog, { clientId: clientId }),
            contentMaxWidth: "max-w-md",
            isDismissable: true,
        }));
    };
    if (isLoading) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "flex h-full items-center justify-center", children: (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "lg" }) }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4 md:gap-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "rounded-xl bg-white p-4 shadow-sm md:p-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-xl font-semibold text-gray-900 md:text-2xl", children: "Integrations" }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-gray-500", children: "Connect third-party services and platforms to extend your system capabilities." })] }), (0, jsx_runtime_1.jsxs)("div", { className: "mt-4 grid grid-cols-2 gap-3 sm:grid-cols-2 md:mt-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "rounded-lg bg-blue-50 p-3", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-xs text-blue-600 sm:text-sm", children: "Available" }), (0, jsx_runtime_1.jsx)("p", { className: "text-lg font-semibold text-blue-900 sm:text-xl", children: availableIntegrations.length })] }), (0, jsx_runtime_1.jsxs)("div", { className: "rounded-lg bg-green-50 p-3", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-xs text-green-600 sm:text-sm", children: "Active" }), (0, jsx_runtime_1.jsx)("p", { className: "text-lg font-semibold text-green-900 sm:text-xl", children: configurations.filter(function (c) { return c.status === "ACTIVE"; }).length })] })] })] }), (0, jsx_runtime_1.jsx)("div", { className: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3", children: availableIntegrations.map(function (integration) {
                    var config = getConfigForType(integration.type);
                    var isActive = (config === null || config === void 0 ? void 0 : config.status) === "ACTIVE";
                    var isConfigured = !!config;
                    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col rounded-xl bg-white p-5 shadow-sm transition-shadow hover:shadow-md", children: [(0, jsx_runtime_1.jsxs)("div", { className: "mb-4 flex items-start justify-between", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex h-12 w-12 items-center justify-center rounded-lg bg-blue-50", children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: integration.icon, className: "text-2xl text-blue-600" }) }), isConfigured ? ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: isActive ? "success" : "danger", children: isActive ? "Active" : "Inactive" })) : ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: "default", children: "Not Configured" }))] }), (0, jsx_runtime_1.jsx)("h3", { className: "mb-1 text-base font-semibold text-gray-900", children: integration.name }), (0, jsx_runtime_1.jsx)("p", { className: "mb-4 text-sm text-gray-500", children: integration.description }), isActive && integration.type === "DIGITAL_TWIN" && ((0, jsx_runtime_1.jsxs)("div", { className: "mb-4 rounded-lg border border-blue-200 bg-blue-50 p-3", children: [(0, jsx_runtime_1.jsxs)("div", { className: "mb-2 flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:chart-2-linear", className: "text-sm text-blue-600" }), (0, jsx_runtime_1.jsx)("span", { className: "text-xs font-semibold text-blue-700", children: "Telemetry Sync" })] }), (0, jsx_runtime_1.jsx)("p", { className: "mb-3 text-xs text-blue-600", children: "Auto-syncs every 30 min. You can also trigger a manual sync or import historic data." }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", color: "primary", variant: "flat", className: "w-full", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:refresh-linear", className: "text-lg" }), onPress: function () { return handleTelemetrySync(); }, children: "Sync Telemetry" })] })), (0, jsx_runtime_1.jsxs)("div", { className: "mt-auto flex items-center gap-2 border-t border-gray-100 pt-4", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", color: "primary", variant: isConfigured ? "flat" : "solid", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: isConfigured ? "solar:pen-linear" : "solar:plug-circle-linear", className: "text-lg" }), onPress: function () { return handleConfigure(integration); }, className: "flex-1", children: isConfigured ? "Edit Config" : "Configure" }), isConfigured && ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "flat", color: isActive ? "warning" : "success", isIconOnly: true, onPress: function () { return (isActive ? handleDisable(integration) : handleEnable(integration)); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: isActive ? "solar:pause-linear" : "solar:play-linear", className: "text-lg" }) }))] })] }, integration.type));
                }) })] }));
}
